import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Select, Button, Modal, Radio } from 'antd';
import InputField from '../../components/global/InputField';
import TextArea from 'antd/lib/input/TextArea';
import CelaneseAPI from './../../services';
import config, { utils } from './../../config';
import Translation from '../../Translation';


const { Option } = Select;

export default class ManageMessagesModal extends React.Component {
    constructor(props) {
        super(props);
        this.GLOBAL = 'global';
        this.CUSTOM = 'custom';
        this.state = {
            companiesList: [],
            shortMessage: '',
            longMessage: '',
            companiesStateValue: ''
        };
    }

    /**
     * handleChange function is for updating state of each input values
     * @param {event} e event is passed
     * @memberof ManageMessages
     */
    handleChange = (e) => {
        if (e && e.target) {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    /**
     * onChangeCompanies function is for getting companies list when the user selects each company
     * @param {string} value is a company name when the user selects it from input select box
     * @memberof ManageMessages
     */
    onChangeCompanies = (value) => {
        let companiesList = [];
        value.forEach((val) => {
            companiesList.push(val);
        });
        this.setState({
            companiesList: companiesList
        });
    }

    /**
     * toggleCompanySelection function is for changing the company selection between global and custom company selection
     * @memberof ManageMessages
     */
    toggleCompanySelection = (e) => {
        let companiesData = [];
        if (e.target.value === this.GLOBAL) {
            let companiesAPIData = this.props.companiesData || [];
            companiesAPIData.map((val) => {
                if (val.company) {
                    companiesData.push(val.company);
                }
                return true;
            });
        }
        this.setState({
            companiesStateValue: e.target.value,
            companiesList: companiesData
        });
    }

    /**
     * sendMessage function is for sending a message to the listed companies with short and long messages
     * @memberof ManageMessages
     */
    sendMessage = () => {
        this.setState({
            loading: true
        });
        const dataObj = {
            subject: this.state.shortMessage,
            text: this.state.longMessage,
            scopeType: this.state.companiesStateValue === this.GLOBAL ? 'GLOBAL' : 'COMPANY',
            companies: this.state.companiesList
        };
        CelaneseAPI.post(config.API.manageMessages, dataObj).then(resp => {
            if (resp && resp[0] && resp[0]['companies']) {
                this.success(utils.getTranslationText('msg_sent_companies_successfully','Message sent to Companies Successfully'));
            }
            this.setState({
                companiesList: [],
                shortMessage: '',
                longMessage: '',
                companiesStateValue: ''
            });
            this.props.onCreateMessageSuccess();
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    }

    render() {
        let companiesAPIData = this.props.companiesData || [];
        return (
            <Modal visible={this.props.isModalVisible}
                title={<Translation labelName="title_send_message" defaultText="Send Messages"/>}
                footer={null}
                width={750}
                centered
                onCancel={() => this.props.hideManageMessageModal()}
                className="cmp-manage-messages__modal">
                <div>
                    <InputField
                        type='text'
                        label={<Fragment><Translation labelName="lbl_short_message" defaultText="Short Message "/>*</Fragment>}
                        name='shortMessage'
                        maxLength={100}
                        value={this.state.shortMessage}
                        id='shortMessage'
                        onChange={(e) => this.handleChange(e)}
                    />
                </div>
                <div className="inputfield">
                    <label htmlFor="longMessage"><Translation labelName="lbl_long_message" defaultText="Long message"/></label>
                    <TextArea name='longMessage'
                        id='longMessage'
                        className="inputfield-input inputfield"
                        value={this.state.longMessage}
                        onChange={(e) => this.handleChange(e)}></TextArea>
                </div>
                {
                    companiesAPIData && companiesAPIData.length ? (<Fragment>
                        <div>
                            <label><Translation labelName="lbl_select_company" defaultText="Select Companies"/>*</label>
                            <Radio.Group size="small" value={this.state.companiesStateValue} onChange={(e) => this.toggleCompanySelection(e)} style={{ marginBottom: '10px' }} buttonStyle="solid">
                                <Radio value={this.GLOBAL}><Translation labelName="lbl_global" defaultText="Global"/></Radio>
                                <Radio value={this.CUSTOM}><Translation labelName="lbl_custom_list" defaultText="Custom List"/></Radio>
                            </Radio.Group>
                        </div>
                        {
                            this.state.companiesStateValue === this.CUSTOM ? (
                                <div className="inputfield">
                                    <div>
                                        <Select
                                            mode="multiple"
                                            style={{ width: '100%' }}
                                            placeholder={<Translation labelName="lbl_select_company" defaultText="Select Companies"/>}
                                            onChange={this.onChangeCompanies}
                                            value={this.state.companiesList}
                                        >
                                            {
                                                companiesAPIData.map((val, ind) => {
                                                    return <Option key={ind} value={val.company} role={val.company}>{val.company}</Option>
                                                })
                                            }
                                        </Select>
                                    </div>
                                </div>
                            ) : null
                        }
                    </Fragment>) : null
                }
                <Button type="primary"
                    disabled={!this.state.shortMessage || (this.state.companiesList && !this.state.companiesList.length)}
                    loading={this.props.loading}
                    className='btn btn-primary'
                    onClick={this.sendMessage}><Translation labelName="btn_apply" defaultText="Apply"/></Button>
            </Modal>
        );
    }
}

ManageMessagesModal.propTypes = {
    isModalVisible: PropTypes.bool,
    loading: PropTypes.bool,
    companiesData: PropTypes.array,
    onCreateMessageSuccess: PropTypes.func,
    hideManageMessageModal: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/ManageMessagesModal/index.js